// import { FormattedStylingObject, FormattedTileItem } from "@/contentful/types/types";

// interface NumberedTileProps {
// 	variant: string;
// 	tiles: FormattedTileItem[];
// 	formattedSectionStyles: FormattedStylingObject;
// }
export const NumberedTile = ({ tiles, formattedSectionStyles } /*: NumberedTileProps*/ ) => {
	return (
		<div className="grid grid-cols-1 md:grid-cols-4 gap-4 h-full">
			{tiles.map((tile, index) => (
				<div
					key={index}
					className={`flex flex-col p-8 justify-start items-center rounded-xl  h-auto ${tile.backgroundColor} ${formattedSectionStyles.textColor}`}
				>
					<h4 className="!text-xl">{index + 1}.</h4>
					<p className="text-center">{tile.title}</p>
				</div>
			))}
		</div>
	);
};
